import loopMap from 'mn-utils/loopMap';
import faker from '@faker-js/faker';
import {TAssetsAmount} from './types';

export const getAssetsAmount = (): TAssetsAmount => {
  const pending = faker.mersenne.rand(1000);
  const available = faker.mersenne.rand(1000);
  return {
    asset_code: faker.finance.currencyCode(),
    total: pending + available,
    pending,
    available,
  } as TAssetsAmount;
};

export const getAssetsAmountList = (limit: number): TAssetsAmount[] => {
  return loopMap(limit, getAssetsAmount) as TAssetsAmount[];
};
